import { render, staticRenderFns } from "./CaseFiles.vue?vue&type=template&id=2686bdde&scoped=true&"
import script from "./CaseFiles.vue?vue&type=script&lang=ts&"
export * from "./CaseFiles.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFiles.vue?vue&type=style&index=0&id=2686bdde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686bdde",
  null
  
)

export default component.exports